import React from 'react'
import moment from 'moment'
import { modal } from '../../core/utilities/modal'

import { ptiAccessControl } from '../../core/controllers/PTIAccessControl'

export default class PTIAccessControl extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accessControls: null
        }
    }

    componentDidMount() {
        this.checkAccessControls(true);
    }

    checkAccessControls(forceLoad = false) {
        var self = this;
        if(this.props.hasAccessControl || forceLoad) {
            ptiAccessControl.getAccessControls(this.props.buildingId, function(response) {
                self.setState({
                    accessControls: response.data
                });
            });
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.props.hasAccessControl == false && nextProps.hasAccessControl) {
            this.checkAccessControls(true);
        }
    }

    componentDidUpdate() {
    }

    triggerLock(command, deviceId, actionId, systemId, gateId, controlId, access_control_id) {
        modal.showInfo("Sending " + command + " command to door.", "success", "top", "center");

        ptiAccessControl.sendCommand(command, deviceId, actionId, systemId, gateId, controlId, access_control_id, function(response) {
            modal.showInfo("Success!", "success", "top", "center");
        });
    }

    render(){
        var self = this;
        const hasAccessControl = this.props.hasAccessControl;
        const systems = this.state.accessControls;
        var systemStatus = false;

        var connected = 'system-red';
        if (systems != null && systems.length > 0) {
            connected = 'system-green';
            systemStatus = true;
        }
        if(hasAccessControl) {
            return (
                <div class="card">
                    <div class="header">
                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="pe-7s-plug"></i></span> System Controls</h4>
                        <p class="category"><i class={"fa fa-circle " + connected}></i> { systemStatus ? 'System Connected' : 'System Disconnected'} - <small>checks every 5 seconds.</small></p>
                    </div>
                    <div class="content">
                        <hr></hr>
                        <div class="sensors-container">
                        {systems != null && (systems.map(function(system, index) {
                            var openCommand = 0;
                            var releaseCommand = 0;
                            system.actions[0].map(function(action, index) {
                                if (action.label == 'Open') {
                                    openCommand = action.value;
                                } else if (action.label == 'Release') {
                                    releaseCommand = action.value;
                                }
                            });

                            return system.devices.map(function(device, index) {
                                return (
                                    <div class="sensor-info row">
                                        <h5 class="title">
                                            <i class="icon-icons8-door-sensor-filled"></i>
                                            <small><i class="pe-7s-angle-right"></i></small> {device.label}
                                        </h5>
                                        <h5 class="title status col-md-12">
                                            <div class="form-group">
                                                <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={self.triggerLock.bind(self, 'Release', device.value, releaseCommand, system.system.id, system.gateId, system.controlId, system.access_control_id)}>
                                                    <span>Release Door</span>
                                                </button>
                                                <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={self.triggerLock.bind(self, 'Open', device.value, openCommand, system.system.id, system.gateId, system.controlId, system.access_control_id)}>
                                                    <span>Open Door</span>
                                                </button>
                                            </div>
                                        </h5>
                                    </div>
                                )
                            })
                        }))}
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div class="col-md-12">
                <div class="card">
                    <div class="header">
                    <h4 class="title"><i class="pe-7s-plug"></i><small><i class="pe-7s-angle-right"></i></small> PTI Access Control</h4>
                        <p class="category"><i class="fa fa-circle "></i> No PTI Access Control Integrations found.</p>
                    </div>
                    <div class="content">
                    </div>
                </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/Building/PTIAccessControl.jsx